import './App.css'

import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import { createStore } from 'redux'
import rootReducer from './reducer'
import Base from './features/base/base'
import NoPage from './pages/NoPage/NoPage'
// import { Login } from "./pages/loginPage/loginPage";
import LoginForm from './features/login/login'

import { BrowserRouter, Routes } from 'react-router-dom'
import LogoutPage from './pages/LogoutPage/LogoutPage'
import defaultTheme from './config/theme'
import { ThemeProvider } from '@emotion/react'
import CategoryGrid from './features/CategoryGrid/CategoryGrid'
import OrderHistoryElement from './features/OrderHistoryElement/OrderHistyoryElement'
import Breadcrumbs from './features/Breadcrumbs/Breadcrumbs'

import Error500 from './features/errorPage500/errorPage500'
import Error404 from './features/errorPage404/errorPage404'

const store = createStore(rootReducer)
function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={defaultTheme}>
          <BrowserRouter>
            <Routes>
              <Route
                path="/carts/:id"
                element={
                  <Base>
                    {' '}
                    <Breadcrumbs
                      items={[
                        { title: 'Главная', url: '/' },
                        { title: 'Коризна', url: '/cart' },
                      ]}
                    />{' '}
                    <OrderHistoryElement />{' '}
                  </Base>
                }
              />
              <Route path="/logout" element={<LogoutPage />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/errorPage500" element={<Error500 />} />
              <Route path="/errorPage404" element={<Error404 />} />
              <Route path="/*" element={<Base />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </div>
  )
}
export default App
